import { Component, Input } from '@angular/core';

import { ServiceType } from 'src/app-client/_appCommon/base/AppInterfaceAndBaseClasses';

/**
 * Símbolo con el que se representa cada servicio cuando no hay foto.
 *
 * ÚNICA fuente de verdad: si mañana el símbolo de un concepto cambia, se cambia
 * aquí y queda cambiado en todas las pantallas que usen esta miniatura.
 *
 * 'aligners' es el SVG dibujado de la arcada; el resto son íconos de Material.
 */
const SIMBOLO_POR_SERVICIO = new Map<ServiceType, string>([
  [ServiceType.AditionalAligners, 'aligners'],
  [ServiceType.Upgrade, 'upgrade'],
  [ServiceType.ComplexCase, 'layers'],
  [ServiceType.DentalMonitoring, 'dm'],
]);

/** Para un producto sin foto y sin símbolo propio. */
const SIMBOLO_GENERICO = 'inventory_2';

/**
 * Miniatura de producto para los detalles de pedido.
 *
 * Un renglón de pedido puede no tener foto: los servicios (alineadores
 * adicionales, upgrade, caso complejo) no son filas del catálogo y nunca
 * tendrán una propia, y a un producto simplemente puede no habérsele subido.
 *
 * En vez de dejar que el navegador dibuje el ícono de imagen rota, se muestra
 * el símbolo del concepto. La foto real, cuando existe, se encima al símbolo;
 * si la URL falla al cargar, se oculta y el símbolo vuelve a quedar visible.
 */
@Component({
  selector: 'app-product-thumb',
  templateUrl: './product-thumb.component.html',
  styleUrls: ['./product-thumb.component.css']
})
export class ProductThumbComponent
{
  /** URL de la foto del producto; vacía o nula si no tiene. */
  @Input() public url: string;

  /** Nombre del producto, usado como texto alternativo. */
  @Input() public name: string = '';

  /** Servicio del renglón, si lo es. Decide qué símbolo se dibuja. */
  @Input() public serviceType: ServiceType;

  /** Se enciende si la URL existe pero no carga (404, blob borrado, etc.). */
  public imageFailed: boolean = false;

  public get showImage(): boolean
  {
    // Un servicio no tiene foto propia. La que trae su renglón es la del
    // paquete del caso -no la del servicio-, y mostrarla confunde: el renglón
    // dice "Caso Complejo" con la foto del Ilimitado al lado. Manda el símbolo.
    return !!this.url && !this.imageFailed && !this.tieneSimboloPropio;
  }

  public get symbol(): string
  {
    return SIMBOLO_POR_SERVICIO.get(this.serviceType) ?? SIMBOLO_GENERICO;
  }

  /** OJO: ComplexCase vale 0, así que aquí no sirve preguntar por verdadero. */
  private get tieneSimboloPropio(): boolean
  {
    return SIMBOLO_POR_SERVICIO.has(this.serviceType);
  }
}
